<template>
  <div :class="class_box">
    <div style="margin-bottom: 3px">
      <div class="month" v-on:click="changeMonth(month.m1.y,month.m1.m)" :class="{month_s:mflag === month.m1.m}"
          :style="{color:(mflag === month.m1.m?type:fColor)}">
        <span class="month_text">{{month.m1.m}}月</span>
      </div>
      <div class="month" v-on:click="changeMonth(month.m2.y,month.m2.m)" :class="{month_s:mflag === month.m2.m}"
           :style="{color:(mflag === month.m2.m?type:fColor)}">
        <span class="month_text">{{month.m2.m}}月</span>
      </div>
      <div class="month" v-on:click="changeMonth(month.m3.y,month.m3.m)" :class="{month_s:mflag === month.m3.m}"
           :style="{color:(mflag === month.m3.m?type:fColor)}">
        <span class="month_text">{{month.m3.m}}月</span>
      </div>
      <div class="month" v-on:click="changeMonth(month.m4.y,month.m4.m)" :class="{month_s:mflag === month.m4.m}"
           :style="{color:(mflag === month.m4.m?type:fColor)}">
        <span class="month_text">{{month.m4.m}}月</span>
      </div>
      <div class="month" v-on:click="changeMonth(month.m5.y,month.m5.m)" :class="{month_s:mflag === month.m5.m}"
           :style="{color:(mflag === month.m5.m?type:fColor)}">
        <span class="month_text">{{month.m5.m}}月</span>
      </div>
      <div class="month" v-on:click="changeMonth(month.m6.y,month.m6.m)" :class="{month_s:mflag === month.m6.m}"
           :style="{color:(mflag === month.m6.m?type:fColor)}">
        <span class="month_text">{{month.m6.m}}月</span>
      </div>
      <div class="month" v-on:click="changeMonth(month.m7.y,month.m7.m)" :class="{month_s:mflag === month.m7.m}"
           :style="{color:(mflag === month.m7.m?type:fColor)}">
        <span class="month_text">当月</span>
      </div>
    </div>
    <div style="width: 100%;height: 10px;margin-top: 8px">
      <div class="month_selected" :class="{month_selected_t:mflag === month.m1.m}"
           :style="{backgroundColor:(mflag === month.m1.m?type:'')}"></div>
      <div class="month_selected" :class="{month_selected_t:mflag === month.m2.m}"
           :style="{backgroundColor:(mflag === month.m2.m?type:'')}"></div>
      <div class="month_selected" :class="{month_selected_t:mflag === month.m3.m}"
           :style="{backgroundColor:(mflag === month.m3.m?type:'')}"></div>
      <div class="month_selected" :class="{month_selected_t:mflag === month.m4.m}"
           :style="{backgroundColor:(mflag === month.m4.m?type:'')}"></div>
      <div class="month_selected" :class="{month_selected_t:mflag === month.m5.m}"
           :style="{backgroundColor:(mflag === month.m5.m?type:'')}"></div>
      <div class="month_selected" :class="{month_selected_t:mflag === month.m6.m}"
           :style="{backgroundColor:(mflag === month.m6.m?type:'')}"></div>
      <div class="month_selected" :class="{month_selected_t:mflag === month.m7.m}"
           :style="{backgroundColor:(mflag === month.m7.m?type:'')}"></div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'MonthChecker',
    display: '月份选择框',
    data() {
      return {
        month_count: 0,
        year_count: 0,
        showFlag: 1,
        mflag: 0,
        yflag: 0,
        fColor: '#ED7C76',
        preCls: 'month_box',
        month: {m1: {y: 18,m: 10},
          m2: {y: 18,m: 11},
          m3: {y: 18,m: 12},
          m4: {y: 19,m: 1},
          m5: {y: 19,m: 2},
          m6: {y: 19,m: 3},
          m7: {y: 19,m: 4}
        },
      }
    },
    props: {
      color: String,
      type: String
    },
    computed: {
      class_box() {
        let {preCls, type,} = this
        let className = [
          `${preCls}`,
          {
            [`${preCls}-${type}`]: !!type,
          },
        ]
        return className
      },
    },
    created: function() {
      let myDate = new Date();
      let year = myDate.getFullYear();
      let month = myDate.getMonth() + 1;
      this.mflag = month;
      this.yflag = year;
      this.month.m7.y = year;
      this.month.m7.m = month;
      if (this.type === 'red'){
      this.fColor = '#c2c2d5';
      }
      if (month < 10) {
        month = '0' + month.toString();
      } else {
        month = month.toString();
      }
      this.$emit('checkMonth',year.toString() + month);

      this.monthReduce(this.month.m7.y,this.month.m7.m);
      this.month.m6.y = this.year_count;
      this.month.m6.m = this.month_count;
      this.monthReduce(this.month.m6.y,this.month.m6.m);
      this.month.m5.y = this.year_count;
      this.month.m5.m = this.month_count;
      this.monthReduce(this.month.m5.y,this.month.m5.m);
      this.month.m4.y = this.year_count;
      this.month.m4.m = this.month_count;
      this.monthReduce(this.month.m4.y,this.month.m4.m);
      this.month.m3.y = this.year_count;
      this.month.m3.m = this.month_count;
      this.monthReduce(this.month.m3.y,this.month.m3.m);
      this.month.m2.y = this.year_count;
      this.month.m2.m = this.month_count;
      this.monthReduce(this.month.m2.y,this.month.m2.m);
      this.month.m1.y = this.year_count;
      this.month.m1.m = this.month_count;
    },
    methods: {
      changeMonth: function (year,month) {
        this.mflag = month;
        if (month < 10) {
          month = '0' + month.toString();
        } else {
          month = month.toString();
        }
        this.$emit('checkMonth',year.toString() + month);
      },
      monthReduce: function (year,month) {
        if (month !== 1) {
          this.month_count = month - 1;
          this.year_count = year;
        } else {
          this.month_count = 12;
          this.year_count = year - 1;
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/monthChecker/monthChecker.vue